import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import classNames from 'classnames';
import HelpArticleLink from 'components/Page/HelpArticleLink';

// Components
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';

interface Props {
  title: string | React.ReactNode;
  subheader: string | React.ReactNode;
  helpLinkMeta?: {
    link: string;
    text: string;
  };
  className?: string;
  subheaderClassName?: string;
}

function InfoCard({ title, subheader, helpLinkMeta, className, subheaderClassName }: Props) {
  const classes = useStyles();
  return (
    <Card className={classNames(classes.root, className)}>
      <CardHeader title={title} subheader={subheader} classes={{ subheader: subheaderClassName }} />
      {helpLinkMeta && (
        <div className={classes.helpLink}>
          <HelpArticleLink link={helpLinkMeta.link} text={helpLinkMeta.text} />
        </div>
      )}
    </Card>
  );
}

const useStyles = makeStyles(theme => {
  return {
    root: {
      marginBottom: theme.spacing(3),
    },
    helpLink: {
      display: 'flex',
      justifyContent: 'flex-end',
      padding: theme.spacing(2),
      paddingTop: 0,
    },
  };
});

export default InfoCard;
